<template>
  <lb-drawer
    :value="value"
    heading="Summary"
    Maxwidth="1665"
    @input="$emit('input', $event)"
    data-testid="info-owner-summary-drawer"
  >
    <template v-slot:body>
      <!-- Summary Table -->
      <v-simple-table
        v-if="hasSummaryData"
        class="simple-table border-on"
        data-testid="info-owner-summary__table"
      >
        <thead class="tableHeaderBg">
          <tr>
            <th scope="name" class="tableHeaderBg">Requested From</th>
            <th scope="pending" class="tableHeaderBg text-center">Pending Submission</th>
            <th scope="wating-approval" class="tableHeaderBg text-center">Pending Re-Submission</th>
            <th scope="closed" class="tableHeaderBg text-center">Closed/Approved</th>
            <th scope="cancelled" class="tableHeaderBg text-center">Cancelled</th>
            <th scope="last-mail-date" class="tableHeaderBg text-center" style="min-width: 120px">
              Last Mail Sent
            </th>
            <th scope="mail-action" class="tableHeaderBg text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, key) in summaryList"
            :key="key"
            data-testid="info-owner-summary__row"
          >
            <!-- Requested From -->
            <td class="d-flex align-center justify-space-between width-max-content gap-2">
              {{ item.name || '' }}
              <v-icon>mdi-email-outline</v-icon>
            </td>

            <!-- Pending Submission -->
            <td class="text-center">
              <span v-if="item.pending">{{ item.pending || 0 }}</span>
            </td>

            <!-- Pending Re-Submission -->
            <td class="text-center">
              <span v-if="item.approve">{{ item.approve || 0 }}</span>
            </td>

            <!-- Closed/Approved -->
            <td class="text-center">
              <span v-if="item.close">{{ item.close || 0 }}</span>
            </td>

            <!-- Cancelled -->
            <td class="text-center">
              <span v-if="item.cancel">{{ item.cancel || 0 }}</span>
            </td>

            <!-- Last Mail Sent -->
            <td class="text-center">
              <div v-if="item.lastmail" class="font-weight-bold caption">
                {{ formatDate(item.lastmail) }}
              </div>
            </td>

            <!-- Action -->
            <td class="text-center">
              <!-- All emails sent -->
              <div v-if="(item.mailpending || 0) === 0" class="success--text d-flex">
                <v-icon color="green">mdi-check-circle</v-icon>
                <v-btn
                  v-if="hasEditRights"
                  text
                  class="ml-2 text-capitalize secondaryBtn"
                  @click="$emit('send-mail', 'reminder', item._id)"
                  data-testid="info-owner-summary__followup-btn"
                >
                  <span>Follow-Up</span>
                </v-btn>
              </div>

              <!-- Pending emails -->
              <div v-else class="info--text">
                <div class="d-flex align-center justify-center">
                  <v-icon color="blue">mdi-timer-sand</v-icon>
                  <span>{{ item.mailpending || 0 }}</span>
                  <v-btn
                    v-if="hasEditRights"
                    text
                    class="ml-2 text-capitalize secondaryBtn"
                    @click="$emit('send-mail', 'reminder', item._id)"
                    data-testid="info-owner-summary__send-btn"
                  >
                    <span>Send</span>
                  </v-btn>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <!-- Empty State -->
      <div
        v-else
        class="grey--text title"
        data-testid="info-owner-summary__empty-state"
      >
        No Data available
      </div>
    </template>

    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn
        class="primary"
        @click="$emit('input', false)"
        data-testid="info-owner-summary__close-btn"
      >
        <span>Close</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'InfoOwnerSummaryDrawer',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    summaryList: {
      type: Object,
      default: () => ({}),
    },
    hasEditRights: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Checks if summary data exists
     * @returns {boolean}
     */
    hasSummaryData() {
      return Object.keys(this.summaryList).length > 0;
    },
  },
  methods: {
    /**
     * Formats a date using Nova formatter
     * @param {string|Date} date - The date to format
     * @returns {string} Formatted date string
     */
    formatDate(date) {
      return this.$nova.formatDate(date);
    },
  },
};
</script>
